import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { ReferenceArea } from '../../reference-areas/models/reference-area';

@Pipe({
  name: 'referenceAreaColor'
})
export class ReferenceAreaColorPipe implements PipeTransform {

  transform(referenceArea: ReferenceArea, ...args: unknown[]): unknown {
    const legends = environment.config.map.legends;
    const currentLegend = legends.find(legend => legend.name.toLowerCase() === (referenceArea.type.toLowerCase() + "s"))
    return currentLegend ? currentLegend.style["background-color"] : '#000';
  }


}
